import React from 'react';
import logo from './logo.svg';
import './App.css';
import AppRoute from './routes/Route';

function App() {
  return (
    <AppRoute></AppRoute>
  );
}

export default App;
